import type { ConfidenceBand } from './suggestion-types';

/* High >= 0.90, Medium 0.75-0.89, Low < 0.75 (design section 1). */
export const HIGH_FROM = 0.9;
export const MEDIUM_FROM = 0.75;

export function bandOf(confidence: number): ConfidenceBand {
  if (confidence >= HIGH_FROM) {
    return 'high';
  }

  return confidence >= MEDIUM_FROM ? 'medium' : 'low';
}

export const BAND_LABELS: Record<ConfidenceBand, string> = {
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

export const percent = (confidence: number) =>
  `${Math.round(confidence * 100)}%`;
